import Vue from 'vue'
import { addProtocol, imageFormat, srcSet } from '@/@next/helpers'
import { isPublished, filterPublishableItem } from '@/@next/helpers/publishable'

Vue.filter('addProtocol', addProtocol)
Vue.filter('imageFormat', imageFormat)
Vue.filter('srcSet', srcSet)
Vue.filter('isPublished', isPublished)
Vue.filter('filterPublishableItem', filterPublishableItem)
